import { gettext } from '@eventbrite/i18n';
import {
    getFormValidationAdornment,
    TextField,
    Typography,
} from '@eventbrite/marmalade';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAppContext } from '../../../AppContext';
import { sanitizeText } from '../../../shared';
import { CreateAccountFormValues } from '../types';

export enum ConfirmEmailFormFieldTestId {
    Field = 'CreateAccountConfirmEmailFormField',
}

export const ConfirmEmailFormField = () => {
    const { control, watch } = useFormContext<CreateAccountFormValues>();
    const { isSubmittingCreateAccountForm } = useAppContext();
    const email = watch('email');

    const emailMessage = gettext("Email address doesn't match.").toString();

    return (
        <Controller
            name="confirmEmail"
            control={control}
            rules={{
                required: {
                    value: true,
                    message: gettext(
                        'Please enter a valid email address.',
                    ).toString(),
                },
                validate: {
                    validEmail: (value) => {
                        if (value && value !== email) {
                            return emailMessage;
                        }
                        return true;
                    },
                },
            }}
            render={({ field, fieldState: { error } }) => (
                <>
                    <TextField
                        autoComplete="off"
                        data-testid={ConfirmEmailFormFieldTestId.Field}
                        hasError={!!error}
                        helperText={error && error.message}
                        id="create-account-confirm-email"
                        label={gettext('Confirm email address').toString()}
                        maxLength={100}
                        validationAdornment={getFormValidationAdornment({
                            hasError: !!error,
                        })}
                        {...field}
                        value={field.value || ''}
                        onChange={(value) => {
                            field.onChange({
                                target: { value: sanitizeText(value) },
                            });
                        }}
                        disabled={isSubmittingCreateAccountForm}
                        required
                    />
                    {!error && field.value && field.value !== email && (
                        <Typography as="p" variant="body-sm">
                            {emailMessage}
                        </Typography>
                    )}
                </>
            )}
        />
    );
};
